import { Link } from "react-router-dom";
import { useGetPageQuery } from "../store/api/contentApi";

const FALLBACK_SECTIONS = [
  {
    title: "1. Information We Collect",
    body: `We collect information you provide directly to us when you create an account, make a booking, or contact us for support. This includes your full name, email address, phone number, WhatsApp number, billing address, and payment information. We may also collect information automatically when you use our platform, such as your IP address, browser type, operating system, pages visited, and the date and time of your visit.`,
  },
  {
    title: "2. How We Use Your Information",
    body: `We use the information we collect to process and manage your bookings, send booking confirmations and reminders via email and WhatsApp, provide customer support, improve and personalise our services, send promotional communications (only with your consent), comply with legal obligations, and prevent fraud or unauthorised access.`,
  },
  {
    title: "3. Data Storage and Security",
    body: `Your data is stored on secure servers protected by industry-standard encryption. Payment information is processed through PCI-DSS compliant payment gateways and is never stored on our servers in raw form.`,
  },
  {
    title: "4. Contact Us",
    body: `If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us at: hello@contentour.com`,
  },
];

export default function PrivacyPolicy() {
  const { data: pageRes, isLoading } = useGetPageQuery("privacy");
  const pageBody = pageRes?.data?.body || null;

  return (
    <div>
      {/* Hero banner */}
      <div className="relative bg-[#1a7b7b]">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div
            className="absolute -top-10 -right-10 w-52 md:w-72 opacity-80"
            style={{
              background: "linear-gradient(135deg, #a8edea 0%, #fed6e3 40%, #c3f0e8 70%, #b8d4f8 100%)",
              borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70%",
              height: "220px",
              filter: "blur(2px)",
            }}
          />
          <div
            className="absolute -bottom-10 -left-10 w-40 md:w-56 opacity-50"
            style={{
              background: "linear-gradient(135deg, #c3f0e8 0%, #a8edea 50%, #fed6e3 100%)",
              borderRadius: "70% 30% 30% 70% / 70% 70% 30% 30%",
              height: "180px",
              filter: "blur(2px)",
            }}
          />
        </div>

        <div className="container mx-auto px-4 py-14 md:py-20 flex flex-col items-center gap-4 relative z-10">
          <div className="flex flex-wrap items-center justify-center gap-1 text-white/70 font-manrope-regular text-sm">
            <Link to="/" className="hover:text-white transition-colors">Home</Link>
            <span>/</span>
            <span className="text-white">Privacy policy</span>
          </div>
          <h1 className="font-manrope-bold text-[28px] md:text-[48px] text-white text-center">
            Privacy policy
          </h1>
          <p className="font-manrope-regular text-sm text-white/70">
            Last updated: April 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="bg-bg py-12 md:py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <div className="bg-white rounded-2xl p-6 md:p-10 shadow-sm flex flex-col gap-8">
            <p className="font-manrope-regular text-base text-secondary leading-relaxed">
              Welcome to Contentour Bonaire. We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our booking platform.
            </p>

            {isLoading && (
              <div className="flex flex-col gap-6 animate-pulse">
                {Array.from({ length: 4 }).map((_, i) => (
                  <div key={i} className="flex flex-col gap-2">
                    <div className="h-5 bg-gray-200 rounded w-48" />
                    <div className="h-4 bg-gray-100 rounded w-full" />
                    <div className="h-4 bg-gray-100 rounded w-4/5" />
                  </div>
                ))}
              </div>
            )}

            {!isLoading && pageBody ? (
              <div
                className="rich-content"
                dangerouslySetInnerHTML={{ __html: pageBody }}
              />
            ) : !isLoading && (
              FALLBACK_SECTIONS.map(({ title, body }) => (
                <div key={title} className="flex flex-col gap-3">
                  <h2 className="font-manrope-bold text-lg text-black">{title}</h2>
                  <p className="font-manrope-regular text-base text-secondary leading-relaxed">{body}</p>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
